<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="mode()">
        <ng-container *ngSwitchCase="'nohomesmall'">
            {{zielText + ' ' + ziel() }}
        </ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mbfilters"></ng-container>
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn w100" [class.tmp-no-bottom-border]="!bottomleftradius()"
        [class.tmpnorightborder]="norightborder()" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <!-- <mat-icon class="rotate" fontIcon="flight"></mat-icon> -->
        <svg class="rotate" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="#7c7c7d"
                d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
        </svg>
        <span multilang style="color:#7c7c7d">{{zielText + ' ' + ziel() }}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #homemodeMobile>
    <button class="tmpbtn  w100" [class.tmpnorightborder]="norightborder()" [class.tmp-bottom-left]="bottomleftradius()"
        [class.tmp-no-bottom-border]="!bottomleftradius()" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <!-- <mat-icon class="rotate" fontIcon="flight"></mat-icon> -->
        <svg style="color: #7c7c7d;" class="rotate" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24"
            width="24px">
            <path d="M0 0h24v24H0z" fill="none" />
            <path fill="#7c7c7d"
                d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
        </svg>
        <span multilang style="color:#7c7c7d">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn tmpnorightborder w100" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <!-- <mat-icon class="rotate" fontIcon="flight"></mat-icon> -->
        <svg class="rotate" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
            fill="#7c7c7d">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
        </svg>
        <span multilang>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" placeholder="{{ziel()}} hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" placeholder="{{ziel()}} hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper customscroll" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        @if(selectedList?.length > 0) {
        <div class="title-wrapper">
            <span multilang style="font-size:18px;font-weight: 600;color:var(--coraldarkgrey);">Ausgewählte
                Filter</span>
            <button style="font-size:16px;font-weight:400;color:var(--coralblue);" (click)="removeAllSelected()" multilang>Alles
                löschen</button>
        </div>
        <div class="selected-wrapper">
            <ng-container *ngFor="let item of selectedList; let k = index">
                <div class="selected-item">
                    <span multilang>{{item.name}} </span>
                    <button (click)="removeFromSelected(k)">
                        <mat-icon class="clearbtn">clear</mat-icon>
                    </button>
                </div>
            </ng-container>
        </div>
        }
        @if(mySearchControl?.value?.length > 0 && (searchObj | async); as airports) {
        @for (item of airports; track $index) {
        @if(isNotInlist(item)) {
        <button class="item-wrapper" (click)="selectValue(item)">
            <div class="item-body">
                <span multilang class="first-item-line">{{item.name}} <span multilang
                        class="second-item-line">{{item.code}}</span></span>
            </div>
        </button>
        }
        }
        } @else {
        <div class="cc2">
            <span multilang class="stattitle">{{'Flughäfen nach Regionen' }}</span>
            <div class="cc4-news">
                <div class="cc5">
                    <button (click)="checkNord()" style="display:flex;align-items: center;width:7rem;column-gap:0.5rem">
                        @if(!flughafen_nord){
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt="">
                        }
                        <span multilang class="cc6">{{'Nord' }}</span>
                    </button>
                    <button
                        (click)="hideNord=!hideNord"><mat-icon>{{hideNord?"expand_more":"expand_less"}}</mat-icon></button>
                </div>
                @if(!hideNord){
                <div style="display:grid; grid-template-columns: 1fr;padding-left:1.5rem;row-gap:0.7rem; ">
                    @for (flg of de_flughafen; track $index) {
                    @if(flg.region == "nord"){
                    <button style="width:100%;display:flex;column-gap:0.5rem;" (click)="addAirport(flg)">
                        @if(isNotInlist(flg)) {
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt=""> }
                        <span multilang class="cc6">{{flg.name }}</span>

                    </button>
                    }}
                </div>
                }
                <div class="cc5">
                    <button (click)="checkSud()" style="display:flex;align-items: center;width:7rem;column-gap:0.5rem">
                        @if(!flughafen_sud){
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt="">
                        }
                        <span multilang class="cc6">{{'Sud' }}</span>
                    </button>
                    <button
                        (click)="hideSud=!hideSud"><mat-icon>{{hideSud?"expand_more":"expand_less"}}</mat-icon></button>
                </div>
                @if(!hideSud){
                <div style="display:grid; grid-template-columns: 1fr;padding-left:1.5rem;row-gap:0.7rem; ">
                    @for (flg of de_flughafen; track $index) {
                    @if(flg.region == "sud"){
                    <button style="width:100%;display:flex;column-gap:0.5rem;" (click)="addAirport(flg)">
                        @if(isNotInlist(flg)) {
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt=""> }
                        <span multilang class="cc6">{{flg.name }}</span>
                    </button>
                    }}
                </div> }
                <div class="cc5">
                    <button (click)="checkOst()" style="display:flex;align-items: center;width:7rem;column-gap:0.5rem">
                        @if(!flughafen_ost){
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt="">
                        }
                        <span multilang class="cc6">{{'Ost' }}</span>
                    </button>
                    <button
                        (click)="hideOst=!hideOst"><mat-icon>{{hideOst?"expand_more":"expand_less"}}</mat-icon></button>
                </div>
                @if(!hideOst){
                <div style="display:grid; grid-template-columns: 1fr;padding-left:1.5rem;row-gap:0.7rem; ">
                    @for (flg of de_flughafen; track $index) {
                    @if(flg.region == "ost"){
                    <button style="width:100%;display:flex;column-gap:0.5rem;" (click)="addAirport(flg)">
                        @if(isNotInlist(flg)) {
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt=""> }
                        <span multilang class="cc6">{{flg.name }}</span>
                    </button>
                    }}
                </div> }
                <div class="cc5">
                    <button (click)="checkWest()" style="display:flex;align-items: center;width:7rem;column-gap:0.5rem">
                        @if(!flughafen_west){
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt="">
                        }
                        <span multilang class="cc6">{{'West' }}</span>
                    </button>
                    <button
                        (click)="hideWest=!hideWest"><mat-icon>{{hideWest?"expand_more":"expand_less"}}</mat-icon></button>
                </div>
                @if(!hideWest){
                <div style="display:grid; grid-template-columns: 1fr ;padding-left:1.5rem;row-gap:0.7rem; ">
                    @for (flg of de_flughafen; track $index) {
                    @if(flg.region == "west"){
                    <button style="width:100%;display:flex;column-gap:0.5rem;" (click)="addAirport(flg)">
                        @if(isNotInlist(flg)) {
                        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/Checkbox base (1).svg" alt=""> }
                        <span multilang class="cc6">{{flg.name }}</span>
                    </button>
                    }}
                </div> }
            </div>
        </div>

        <div class="cc2">
            <span multilang class="stattitle">{{'Deutsche Abflughäfen' }}</span>
            <div class="cc4">
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: de_flughafen}"></ng-container>
            </div>
        </div>

        <div class="cc2">
            <span multilang class="stattitle">{{'Europäische Abflughäfen' }}</span>
            <div class="cc4">
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: fr_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: es_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: at_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: ch_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: lu_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: be_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: nl_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: pl_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: dk_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: cz_flughafen}"></ng-container>
            </div>
        </div>
        }
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" (click)="take()" multilang>{{'ÜBERNEHMEN' }}</button>
    </div>
</ng-template>

<ng-template #statairplist let-airlist="airlist">
    @for (flg of airlist; track $index) {
    <button class="cc5" (click)="addAirport(flg)">
        @if(isNotInlist(flg)) {
        <img src="../../../../assets/icons/Checkbox base.svg" alt="">
        }@else{
        <img src="../../../../assets/icons/Checkbox base (1).svg" alt="">
        }
        <span multilang class="cc6">{{flg.name }}</span>
    </button>
    }
</ng-template>